// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-6f89e9f3]{text-align:center}.content .el-button[data-v-6f89e9f3]{margin-top:1.041667rem}", ""]);
// Exports
module.exports = exports;
